<template>
  <div class="text-area-container">
    <div
      v-if="label"
      class="text-area-label-container"
    >
      <label class="text-area-label">{{ label }}</label>
    </div>
    <textarea
      ref="textarea"
      class="text-area"
      :value="modelValue"
      @input="onChanged"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TextArea',
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onChanged(e: any): void {
      emit('update:modelValue', e.currentTarget.value)
    }

    return {
      onChanged
    }
  },
  mounted() {
    if (this.focus) {
      const textarea = this.$refs.textarea as HTMLTextAreaElement
      textarea.focus()
    }
  }
})
</script>

<style scoped lang="scss">

.text-area-container {
  text-align: left;
  
  > .text-area-label-container {
    text-align: left;
    
    > .text-area-label {
      @include input-text-field-label;
    }
  }

  > .text-area {
    @include input-text-area;
  }
}

</style>
